/**
 * Shared path/query-key builders for `GET /v1/areas/{areaId}/map`, used by
 * both `useAreaMap` (a single selected area) and `useAreaMaps` (fan-out
 * preloading across every authorized area), so both consumers are guaranteed
 * to share the same TanStack Query cache entries rather than requesting the
 * same area's map twice.
 */
export function buildAreaMapPath(areaId: string): string {
  return `/v1/areas/${encodeURIComponent(areaId)}/map`;
}

export function areaMapQueryKey(
  deploymentId: string,
  areaId: string | undefined
): readonly unknown[] {
  return ["area-map", deploymentId, areaId];
}
